module.exports = __webpack_public_path__ + "img/wxicon.099a8630.svg";